import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchTires() {
  try {
    const tires = yield call(function() {
      return Api.get('/dealer/tires');
    });
    yield put({type: 'FETCH_TIRES.SUCCESS', tires})
  } catch (error) {
    yield put({type: 'FETCH_TIRES.FAILURE', error})
  }
}

export function* watchFetchTires() {
  yield takeEvery('FETCH_TIRES.REQUEST', fetchTires);
}

function* saveTires(action) {
  try {
    const tires = yield call(function () {
      return Api.post('/dealer/tires', action.body);
    });

    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.REQUEST'});
    yield put({type: 'SAVE_TIRES.SUCCESS', tires});
  } catch (error) {
    yield put({type: 'SAVE_TIRES.FAILURE', error})
  }
}

export function* watchSaveTires() {
  yield takeEvery('SAVE_TIRES.REQUEST', saveTires)
}



// WEBPACK FOOTER //
// ./src/sagas/tires.js